import { render, staticRenderFns } from "./IntangiveisPorOrgao.vue?vue&type=template&id=6ce85dbc&scoped=true&"
import script from "./IntangiveisPorOrgao.vue?vue&type=script&lang=js&"
export * from "./IntangiveisPorOrgao.vue?vue&type=script&lang=js&"
import style0 from "./IntangiveisPorOrgao.vue?vue&type=style&index=0&id=6ce85dbc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce85dbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDivider,VFlex,VSpacer})
